import React, { useState, createContext, useEffect } from 'react';
import { SettingsContextType } from '../types/settingsContextType';
import FeatureManagement from '../models/FeatureManagement';
import { getFeatureGates } from '../providers/featuresApi';
import logger from '../providers/logger';

export const SettingsContext = createContext<SettingsContextType>(
  {} as SettingsContextType
);

interface ISettingsContextProviderProps extends React.PropsWithChildren {}

export const SettingsContextProvider = (
  props: ISettingsContextProviderProps
) => {
  // Set the initial state of the settings in environment variables
  const [settings, setSettings] = useState({
    debugMode: process.env.REACT_APP_DEBUG_MODE
      ? process.env.REACT_APP_DEBUG_MODE === 'true'
      : false,
    showControlsSystemStart: process.env
      .REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SYSTEMSTART
      ? process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SYSTEMSTART === 'true'
      : false,
    showControlsMenu: process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SIDEMENU
      ? process.env.REACT_APP_SHOW_DEV_ADMIN_CONTROLS_SIDEMENU === 'true'
      : false,
    traceLogToConsole: process.env.REACT_APP_LOG_TO_CONSOLE
      ? process.env.REACT_APP_LOG_TO_CONSOLE === 'true'
      : false,
  });
  const [traceLog, setTraceLog] = useState<string[]>([]);
  const [uiUpdateDateVersion, setUIUpdateDateVersion] = useState('20241018');
  const [featureManagement, setFeatureManagement] = useState<FeatureManagement>(
    new FeatureManagement()
  );

  const getFeatureGatesForContext = async () => {
    try {
      const featureGates = await getFeatureGates();
      featureGates.isLoaded = true;
      setFeatureManagement(featureGates);
    } catch (e: any) {
      logger.error(`Error getting feature gates: ${e?.message}`);
      setTraceLog([...traceLog, `Error getting feature gates: ${e?.message}`]);
      setFeatureManagement(new FeatureManagement({ isLoaded: true }));
    }
  };

  useEffect(() => {
    getFeatureGatesForContext();
  }, []);

  return (
    <SettingsContext.Provider
      value={{
        settings,
        setSettings,
        traceLog,
        setTraceLog,
        uiUpdateDateVersion,
        featureManagement,
        setFeatureManagement,
        getFeatureGatesForContext,
      }}
    >
      {props.children}
    </SettingsContext.Provider>
  );
};
